const setInputBoxShadow = (color = '#eeeeee') => ({
  WebkitBoxShadow: `0px 0px 20px 1000px ${color} inset`,
});

export default setInputBoxShadow;
